"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topics = void 0;
exports.topics = {
    SCHOOLS: {
        plural: 'Schools',
        pluralDetailed: 'Schools',
        breadcrumb: 'Schools',
        iconName: 'School',
        iconColor: 'linear-gradient(225deg, #E6EA2D 0%, #D3B845 100%)',
    },
    EVENTS: {
        plural: 'Events',
        pluralDetailed: 'Events and Entertainment',
        breadcrumb: 'Events + Entertainment',
        iconName: 'EventNote',
        iconColor: 'linear-gradient(225deg, #B0CD3B 0%, #8CA71E 100%)',
    },
    COMMUNITY: {
        plural: 'Community',
        pluralDetailed: 'Community',
        breadcrumb: 'Community',
        iconName: 'People',
        iconColor: 'linear-gradient(225deg, #B229E2 0%, #843BCD 100%)',
    },
    CAREERS: {
        plural: 'Careers',
        pluralDetailed: 'Careers',
        breadcrumb: 'Careers',
        iconName: 'Work',
        iconColor: 'linear-gradient(225deg, #1FC3E8 0%, #2F86D7 100%)',
    },
    RESTAURANTS: {
        plural: 'Restaurants',
        pluralDetailed: 'Restaurants',
        breadcrumb: 'Restaurants',
        iconName: 'Restaurant',
        iconColor: 'linear-gradient(225deg, #EBC43C 0%, #E28D29 100%)',
    },
    OUTDOORS: {
        plural: 'Outdoors',
        pluralDetailed: 'Outdoors',
        breadcrumb: 'Outdoors',
        iconName: 'Hiking',
        iconColor: 'linear-gradient(225deg, #3BCD76 0%, #28BD99 100%)',
    },
    LIFESTYLE: {
        plural: 'Lifestyle',
        pluralDetailed: 'Lifestyle',
        breadcrumb: 'Lifestyle',
        iconName: 'NaturePeople',
        iconColor: 'linear-gradient(225deg, #70DDEC 0%, #0CA7B0 100%)',
    },
    TODO: {
        plural: 'Things to Do',
        pluralDetailed: 'Things to Do',
        breadcrumb: 'Things to Do',
        iconName: 'Attractions',
        iconColor: 'linear-gradient(225deg, #EA58D4 0%, #B0259A 100%)',
    },
    ARTS: {
        plural: 'Arts & Culture',
        pluralDetailed: 'Arts & Culture',
        breadcrumb: 'Arts & Culture',
        iconName: 'ColorLens',
        iconColor: 'linear-gradient(225deg, #FF7E47 0%, #F44336 100%)',
    },
    HOUSING: {
        plural: 'Housing',
        pluralDetailed: 'Housing',
        breadcrumb: 'Housing',
        iconName: 'Villa',
        iconColor: 'linear-gradient(225deg, #339D83 0%, #008565 100%)',
    },
};
